// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__r29Sg","header":"ClearentDisclaimer_header__x67mZ","inner":"ClearentDisclaimer_inner__3GGb3"};